module.exports = __webpack_public_path__ + "media/section6_h.070af25d.mp3";